
<div class="user-image" [ngStyle]="{ width: size + 'px', height: size + 'px' }">
  @if (user && user.image) {
    <app-image
      [src]="user.image"
      [alt]="user.firstname ?? 'Photographer'"
      preset="avatar"
      aspectRatio="1"
      [sizes]="'42px'"
      [width]="42"
      [height]="42"
    ></app-image>
  }
  @if (user && !user.image && user.roles.includes(UserRoles.photographer)) {
    <i class="fa-solid fa-camera-retro"></i>
  }
  @if (!user || !user.roles.includes(UserRoles.photographer)) {
    <i class="fa-solid fa-user"></i>
  }
</div>
